import routeTypes from './RouteTypes'

const MobileImageUploader = () => import(/* webpackChunkName: "signin-chunk" */ './MobileImageUploader.vue')

export default [
  {
    path: routeTypes.MobileImageUploader.path,
    name: routeTypes.MobileImageUploader.name,
    component: MobileImageUploader,
    meta: {
      route: 'listing',
      title: 'FlexiQuote Image Uploader'
    }
  }
]

